<template>
  <div v-if="options" class="dropdown" :class="{'open': optionsShown, 'selected': selected && !optionsShown}">
    <label v-show="false" for="search-dropdown">
      {{ computedPlaceholder }}
    </label>
    <!-- Dropdown Input -->
    <input
      id="search-dropdown"
      v-model="searchFilter"
      class="dropdown-input"
      :name="name"
      :disabled="disabled"
      :placeholder="computedPlaceholder"
      @focus="showOptions()"
      @blur="handleBlur"
      @input="keyMonitor"
    >

    <!-- Dropdown Menu -->
    <div
      v-show="optionsShown"
      class="dropdown-content"
    >
      <div
        v-for="option in filteredOptions"
        :key="option.value"
        class="dropdown-item"
        @mousedown="selectOption(option)"
      >
        {{ option.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchDropdown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
      note: 'Options of dropdown. An array of options with id and name'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    focusPlaceholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 6,
      note: 'Max items showing'
    }
  },
  data () {
    return {
      optionsShown: false,
      filterVal: ''
    }
  },
  computed: {
    computedPlaceholder () {
      if (this.optionsShown) {
        return this.focusPlaceholder
      }
      return this.placeholder
    },
    searchFilter: {
      get () {
        if (this.filterVal) {
          return this.filterVal
        }

        if (this.selected && this.selected.description && !this.optionsShown) {
          return this.selected.description
        } else {
          return ''
        }
      }
    },
    selected () {
      return this.options.find(option => option.value === this.value)
    },
    filteredOptions () {
      const filtered = []
      const regOption = new RegExp(this.filterVal, 'ig')
      for (const option of this.options) {
        if (this.filterVal.length < 1 || option.description.match(regOption)) {
          if (filtered.length < this.maxItem) filtered.push(option)
        }
      }
      return filtered
    }
  },
  methods: {
    selectOption (option) {
      this.filterVal = ''
      this.optionsShown = false
      this.$emit('input', option.value)
    },
    handleBlur () {
      this.filterVal = ''
      this.optionsShown = false
    },
    showOptions () {
      if (!this.disabled) {
        this.$emit('input', null)
        this.optionsShown = true
      }
    },
    keyMonitor: function (event) {
      this.filterVal = event.currentTarget.value

      if (event.key === 'Enter' && this.filteredOptions[0]) {
        this.selectOption(this.filteredOptions[0])
      }
    }
  },
  template: 'Dropdown'
}
</script>

<style lang="scss" scoped>
  $navy: #032942;
  $grey: #bababa;

  .dropdown {
    position: relative;
    display: block;
    margin: auto;
    background-color: $white;

    &.open {
      box-shadow: 0 0 8px 0 rgba(3, 41, 66, 0.1);

      .dropdown-content {
        box-shadow: 0 0 8px 0 rgba(3, 41, 66, 0.1);
      }

      .dropdown-input {
        border-radius: 4px 4px 0px 0px;
        background-color: $white;
      }
    }

    .dropdown-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    &.selected {
      .dropdown-input {
        padding: $spacing-0 $spacing-16;
      }
    }

    .dropdown-input {
      background: transparent;
      border: solid 1px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      color: $navy;
      display: block;
      font-size: 18px;
      font-weight: 500;
      padding: $spacing-0 $spacing-40 $spacing-0 $spacing-16;
      height: 60px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      outline: none;

      &::placeholder {
        color: $grey;
      }

      &:focus {
        background-color: $white;
      }
    }
    .dropdown-content {
      position: absolute;
      background-color: #fff;
      min-width: 248px;
      max-width: none;
      max-height: 248px;
      border: 1px solid #e7ecf5;
      overflow: auto;
      width: 100%;
      z-index: 1;
      .dropdown-item {
        color: $navy;
        font-size: 17px;
        line-height: 1em;
        padding: $spacing-16;
        text-decoration: none;
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        &:hover {
          background-color: #e7ecf5;
        }
      }
    }
    .dropdown:hover .dropdowncontent {
      display: block;
    }
  }
</style>
